import ContractParties from "./ContractParties";
import LetterHead from "../Contact/LetterHead";

const ContractHead = ({ contract, resource }) => {
  return (
    <>
      {contract.contractHead === "PARTIES" && (
        <ContractParties contract={contract} resourceId={resource.id} />
      )}
      {contract.contractHead === "LETTERHEAD" && (
          <LetterHead isCustomer withPartner={false} />
      )}
    </>
  );
};

export default ContractHead;
